<app-review-section
  *ngIf="form"
  #reviewSection
  [applicationId]="applicationId"
  [sectionId]="sectionIdentifier.DrrCcd_TechnicalData_CommissioningData"
  [title]="'drr-ccd.commissioning-data.section-header' | translate | uppercase"
  [tooltip]="'tooltips.documents-submission.document-header-info' | translate"
  [showTooltip]="environmentService.showDocumentHeaderHintIcon"
  [isDetailsView]="isDetailsView"
  [formGroup]="form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-radio-button-yes-no
      name="is_commissioning_done"
      [label]="'drr-ccd.commissioning-data.commissioning-done' | translate"
      [formControl]="form.controls.is_commissioning_done"
      [style]="'horizontal'"
      [forceDisable]="!reviewSection.isDataEditable"></app-radio-button-yes-no>
  </div>

  <div
    *ngIf="form?.getRawValue().is_commissioning_done"
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-date-picker
      name="commissioning_date"
      [formControl]="form.controls.commissioning_date"
      [label]="'drr-ccd.commissioning-data.date' | translate"
      [forceDisable]="!reviewSection.isDataEditable"></app-date-picker>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <app-file-input-form-control
      [label]="'drr-ccd.commissioning-data.document-info' | translate"
      [data]="data.commissioning_document"
      documentType="drr_ccd_commissioning"
      [required]="true"
      [disabled]="!reviewSection.isDataEditable"
      (formInited)="fileFormInited($event)"></app-file-input-form-control>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <app-checkbox
      [label]="'drr-ccd.commissioning-data.declaration-header' | translate"
      [formControl]="form.controls.is_commissioning_confirmed"
      [forceDisable]="isDetailsView"></app-checkbox>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <label>{{ 'drr-ccd.commissioning-data.declaration-body' | translate }}</label>
  </div>
</app-review-section>
